const exludeOptions = [
    {
        slug: "storvretacentrum",
        types: ["image"]
    },
    {
        slug: "jaktvarvet",
        types: ["image"]
    }
];

export { exludeOptions };
